import styled from "styled-components";
import { useContext } from "react";
import { LanguageContext } from "../../components/LanguageContext";
import { Element } from "react-scroll";
import Button from "../../components/Button";
import Contact from "../../components/Contact";
import sabWork from "../../assets/sab-work.webp";

const ContactPage = ({ DialogTrigger, formStatus, setFormStatus }) => {
  const { language } = useContext(LanguageContext);
  const disabled = formStatus !== "standby";

  return (
    <Wrapper name="contact">
      <ContactWrap>
        <Contact
          dialog={false}
          formStatus={formStatus}
          setFormStatus={setFormStatus}
        />
      </ContactWrap>
    </Wrapper>
  );
};

const Wrapper = styled(Element)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* padding: 20px; */
  background: var(--second-color);
  box-sizing: border-box;
  height: clamp(640px, 92vh, 92vh);
`;

const ContactWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50vw;
  height: 450px;
  padding: 30px;
  @media (max-width: 1000px) {
    width: 100%;
    padding: 10px;
  }
`;

export default ContactPage;
